<template>
  <b-modal
    id="birthday-preview-modal"
    class="custom-modal"
    centered
    title="Preview"
    body-class="py-3"
    hide-footer
    no-close-on-backdrop
  >
    <b-form-group>
      <template slot="label">
        Birthday <span class="text-danger">*</span>
      </template>
      <b-row>
        <b-col md="5" class="mb-3 mb-md-0">
          <b-form-select value="month">
            <option value="month" disabled>Month</option>
            <option v-for="(month, index) in months" :key="`month_${index}`" :value="month">{{ month }}</option>
          </b-form-select>
        </b-col>
        <b-col md="7">
          <b-row>
            <b-col md="6" class="mb-3 mb-md-0">
              <b-form-select value="day">
                <option value="day" disabled>Day</option>
                <option v-for="(day, index) in days" :key="`day_${index}`" :value="day">{{ day }}</option>
              </b-form-select>
            </b-col>
            <b-col md="6">
              <b-form-select value="year">
                <option value="year" disabled>Year</option>
                <option v-for="(year, index) in years" :key="`year_${index}`" :value="year">{{ year }}</option>
              </b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: "BirthdayPreviewModal",
  computed: {
    months() {
      const months = [];
      for(var month=1; month<13; month++) {
        months.push(month < 10 ? `0${month}` : month);
      }
      return months;
    },
    days() {
      const days = [];
      for(var day=1; day<32; day++){
        days.push(day < 10 ? `0${day}` : day);
      }
      return days;
    },
    years() {
      const years = [];
      let year = 1900;
      while (year < new Date().getFullYear()) {
        years.push(year);
        year++;
      }
      return years;
    }
  }
}
</script>
